/**
 * Valores iniciais do formulário de Bank Account.
 */
export const bankAccountDefaults = {
    description: "",
    bankName: "",
    accountType: "corrente",
    agency: "",
    accountNumber: "",
    initialBalance: 0,
    balance: 0,       // Saldo atual (atualizado automaticamente pelas Cloud Functions)
    isDefault: false,  // Se é a conta padrão do tenant
    status: "active"
};
